import React from 'react';

const MemberCardSkeleton = () => (
  <li className="flex items-center gap-3 w-[385px] animate-pulse">
    <div className="w-32 h-32 bg-gray-200 rounded-full flex-shrink-0" />

    <div className="flex-1 font-normal text-lg">
      <div className="h-[27px] bg-gray-200 rounded w-32" />
      <div className="h-6 bg-gray-200 rounded w-40 mb-3" />
      <div className="h-8 bg-gray-200 rounded-full w-full max-w-[160px] flex items-center justify-center gap-2 px-3">
        <div className="w-4 h-4 bg-gray-300 rounded" />
        <div className="h-3 bg-gray-300 rounded w-12" />
      </div>
    </div>
  </li>
);

export default MemberCardSkeleton;
